// Getters (GET*)
export const NOTIFICATIONS_GET = 'NOTIFICATIONS_GET';
export const NOTIFICATIONS_GET_ALL = 'NOTIFICATIONS_GET_ALL';
export const NOTIFICATIONS_GET_TOTAL = 'NOTIFICATIONS_GET_TOTAL';

// Mutations (SET*, ADD*, REMOVE*)
// [ACTION]_[PROPERTY]
export const NOTIFICATIONS_ADD = 'NOTIFICATIONS_ADD';
export const NOTIFICATIONS_REMOVE = 'NOTIFICATIONS_REMOVE';
export const NOTIFICATIONS_SET = 'NOTIFICATIONS_SET';
export const NOTIFICATIONS_SET_EMPTY = 'NOTIFICATIONS_SET_EMPTY';
export const NOTIFICATIONS_SET_MESSAGE = 'NOTIFICATIONS_SET_MESSAGE';
export const NOTIFICATIONS_SET_TOTAL = 'NOTIFICATIONS_SET_TOTAL';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [ACTION]_[PROPERTY]_[STATUS]
export const NOTIFICATIONS_DELETE = 'NOTIFICATIONS_DELETE';
export const NOTIFICATIONS_DELETE_ALL = 'NOTIFICATIONS_DELETE_ALL';
export const NOTIFICATIONS_HIDE = 'NOTIFICATIONS_HIDE';
export const NOTIFICATIONS_SEND = 'NOTIFICATIONS_SEND';
export const NOTIFICATIONS_SEND_TOAST = 'NOTIFICATIONS_SEND_TOAST';
export const NOTIFICATIONS_UPDATE = 'NOTIFICATIONS_UPDATE';
